module.exports = __webpack_public_path__ + "static/media/cabin.769b0ac1.jpeg";